import React from "react";
import "./navbar.css";
const Navbar = () => {
  return (
    <>
      <nav className="navbar bg-light">
        <div className="navbar-brand">
          <img
            src="./images/Graviti Logo 1.png"
            className="d-inline-block align-text-center"
            alt="logo"
          />
        </div>
      </nav>
    </>
  );
};

export default Navbar;
